<script>
import base from '@/views/config/addon-cards/templates/base.vue';
import planCommon from './mixin';
import deviceMixin from './device-mx';
import { getZoomDeviceIdInLink } from '@/flows/helper/vendor-product';
import { flowTypes, pageConfig } from '@/common/service/page-config';
import { planTypes } from '@/common/constants';
import { forCurrentPlanShowInAddonForSoftBundle } from '@/views/config/soft-bundle/helper';
import { mapGetters } from 'vuex';
import { ZOOM_MEETING_SUB_TYPES } from '@/plans/ZOOM_MEETING/common/utils';

export default {
  name: 'DeskPhoneAddon',
  mixins: [base, planCommon, deviceMixin],
  for: (args) => {
    const [, , , , , allPlanMap] = args;
    const hasValidVendorProduct = !!allPlanMap?.__vendorsData?.products?.length
    const enableHardware4Online = window.campaignFlags?.enableHardware4Online

    const dpId = getZoomDeviceIdInLink()
    const isBuyNowAndBasic2ProFlow = [flowTypes.buyNow, flowTypes.basic2pro].includes(pageConfig.type)
    const isUSCABuyNowFlow = isBuyNowAndBasic2ProFlow && pageConfig.plan === planTypes.ZOOM_PHONE && pageConfig.editConfig.category.startsWith('pbx_ZV')
    const isBizPlusBuyNowFlow =
      isBuyNowAndBasic2ProFlow &&
      (pageConfig.plan === planTypes.ZOOM_ONE_BUNDLE || pageConfig.plan === ZOOM_MEETING_SUB_TYPES.ZOOM_ONE_BIZ_PLUS);
    const isProPlusBuyNowFlow = isBuyNowAndBasic2ProFlow && pageConfig.plan === planTypes.ZONE_PRO_PLUS
    const isSoftBundleForZoomDevices = isBuyNowAndBasic2ProFlow && forCurrentPlanShowInAddonForSoftBundle(planTypes.ZOOM_DEVICE$DESK_PHONE);

    return hasValidVendorProduct && enableHardware4Online && (
      !!dpId || isUSCABuyNowFlow || isBizPlusBuyNowFlow || isProPlusBuyNowFlow || isSoftBundleForZoomDevices
    );
  },
  data() {
    return {
      addText: 'View Phones'
    }
  },
  computed: {
    ...mapGetters(['isExistSoftBundleConfig', 'enableHardwareHeadset4OnlinePh2']),
    isDeskPhoneOnly() {
      if (this.isExistSoftBundleConfig) {
        const planTypeList = this.mx_soft_bundle_zoom_device_planTypeList;
        const containPhone = planTypeList.includes(planTypes.ZOOM_DEVICE$DESK_PHONE);
        return containPhone && planTypeList.length === 1;
      }
      return !this.enableHardwareHeadset4OnlinePh2;
    },
  },
  created() {
    this.title = this.isDeskPhoneOnly ? this.$t('billing.hw.desk_phones.addon.title') : 'Desk Phones & Headsets'
    this.description = this.isDeskPhoneOnly ? this.$t('billing.hw.desk_phones.addon.desc') : this.$t('billing.hw.desk_phones.addon.desc')
    this.addText = this.isDeskPhoneOnly ? 'View Phones' : 'View Devices'
  },
  mounted() {
    this.handleCustomZoomDevice()
  },
  methods: {
    handleCustomZoomDevice() {
      this.$nextTick(() => {
        const dpId = getZoomDeviceIdInLink()
        if (dpId === 'custom') {
          this.addOn()
        }
      })
    },
    async addOn() {
      await this.openZoomDeviceDialog()
    }
  }
};
</script>
